import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_PATHS } from '../config/api-paths';
import { SpvApi } from '../tokens/spv.token';
import { FinancingDraft, SpvConnectionStatus, SpvInvoice } from '../models/financing.model';

/**
 * REST-only implementation of `SpvApi` (EM-1736, story EM-1670 — BRS §4.1.3 Primary Flow).
 *
 * Calls:
 *   GET  /services/embedded/api/me/spv/status
 *   POST /services/embedded/api/me/spv/connect
 *   GET  /services/embedded/api/me/spv/invoices?debtorCui=
 *   POST /services/embedded/api/me/financing/drafts/{draftId}/spv-invoices
 *
 * Rule 07 / Rule 10 — no Mock fallback; Rule 09 — the raw `HttpErrorResponse` propagates so the
 * wizard surfaces the backend `detail` beside the manual-entry fallback.
 */
@Injectable()
export class SpvInvoicesRestService implements SpvApi {
  private readonly http = inject(HttpClient);
  private readonly base = `${API_PATHS.EMBEDDED_API_BASE}/me/spv`;

  status(): Observable<SpvConnectionStatus> {
    return this.http.get<SpvConnectionStatus>(`${this.base}/status`);
  }

  connect(): Observable<SpvConnectionStatus> {
    return this.http.post<SpvConnectionStatus>(`${this.base}/connect`, {});
  }

  invoices(debtorCui?: string): Observable<SpvInvoice[]> {
    let params = new HttpParams();
    if (debtorCui) {
      params = params.set('debtorCui', debtorCui);
    }
    return this.http.get<SpvInvoice[]>(`${this.base}/invoices`, { params });
  }

  select(draftId: number, spvIds: string[]): Observable<FinancingDraft> {
    return this.http.post<FinancingDraft>(`${API_PATHS.ME_FINANCING}/drafts/${draftId}/spv-invoices`, { spvIds });
  }
}
